"use strict";

var _createForOfIteratorHelper = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js").default;

var _toConsumableArray = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray.js").default;

var _classCallCheck = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck.js").default;

var _createClass = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass.js").default;

var _possibleConstructorReturn = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js").default;

var _getPrototypeOf = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf.js").default;

var _inherits = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits.js").default;

var _wrapNativeSuper = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper.js").default;

function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZodError = exports.quotelessJson = exports.ZodIssueCode = void 0;

var util_js_1 = require("./helpers/util.js");

exports.ZodIssueCode = util_js_1.util.arrayToEnum(["invalid_type", "invalid_literal", "custom", "invalid_union", "invalid_union_discriminator", "invalid_enum_value", "unrecognized_keys", "invalid_arguments", "invalid_return_type", "invalid_date", "invalid_string", "too_small", "too_big", "invalid_intersection_types", "not_multiple_of", "not_finite"]);

var quotelessJson = function quotelessJson(obj) {
  var json = JSON.stringify(obj, null, 2);
  return json.replace(/"([^"]+)":/g, "$1:");
};

exports.quotelessJson = quotelessJson;

var ZodError = /*#__PURE__*/function (_Error) {
  function ZodError(issues) {
    var _this2;

    _classCallCheck(this, ZodError);

    _this2 = _callSuper(this, ZodError);
    _this2.issues = [];

    _this2.addIssue = function (sub) {
      _this2.issues = [].concat(_toConsumableArray(_this2.issues), [sub]);
    };

    _this2.addIssues = function () {
      var subs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      _this2.issues = [].concat(_toConsumableArray(_this2.issues), _toConsumableArray(subs));
    };

    var actualProto = (this instanceof ZodError ? this.constructor : void 0).prototype;

    if (Object.setPrototypeOf) {
      // eslint-disable-next-line ban/ban
      Object.setPrototypeOf(_this2, actualProto);
    } else {
      _this2.__proto__ = actualProto;
    }

    _this2.name = "ZodError";
    _this2.issues = issues;
    return _this2;
  }

  _inherits(ZodError, _Error);

  return _createClass(ZodError, [{
    key: "errors",
    get: function get() {
      return this.issues;
    }
  }, {
    key: "format",
    value: function format(_mapper) {
      var mapper = _mapper || function (issue) {
        return issue.message;
      };

      var fieldErrors = {
        _errors: []
      };

      var _processError = function processError(error) {
        var _iterator = _createForOfIteratorHelper(error.issues),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var issue = _step.value;

            if (issue.code === "invalid_union") {
              issue.unionErrors.map(_processError);
            } else if (issue.code === "invalid_return_type") {
              _processError(issue.returnTypeError);
            } else if (issue.code === "invalid_arguments") {
              _processError(issue.argumentsError);
            } else if (issue.path.length === 0) {
              fieldErrors._errors.push(mapper(issue));
            } else {
              var curr = fieldErrors;
              var i = 0;

              while (i < issue.path.length) {
                var el = issue.path[i];
                var terminal = i === issue.path.length - 1;

                if (!terminal) {
                  curr[el] = curr[el] || {
                    _errors: []
                  }; // if (typeof el === "string") {
                  //   curr[el] = curr[el] || { _errors: [] };
                  // } else if (typeof el === "number") {
                  //   const errorArray: any = [];
                  //   errorArray._errors = [];
                  //   curr[el] = curr[el] || errorArray;
                  // }
                } else {
                  curr[el] = curr[el] || {
                    _errors: []
                  };

                  curr[el]._errors.push(mapper(issue));
                }

                curr = curr[el];
                i++;
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      };

      _processError(this);

      return fieldErrors;
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.message;
    }
  }, {
    key: "message",
    get: function get() {
      return JSON.stringify(this.issues, util_js_1.util.jsonStringifyReplacer, 2);
    }
  }, {
    key: "isEmpty",
    get: function get() {
      return this.issues.length === 0;
    }
  }, {
    key: "flatten",
    value: function flatten() {
      var mapper = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (issue) {
        return issue.message;
      };
      var fieldErrors = {};
      var formErrors = [];

      var _iterator2 = _createForOfIteratorHelper(this.issues),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var sub = _step2.value;

          if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
          } else {
            formErrors.push(mapper(sub));
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return {
        formErrors: formErrors,
        fieldErrors: fieldErrors
      };
    }
  }, {
    key: "formErrors",
    get: function get() {
      return this.flatten();
    }
  }], [{
    key: "assert",
    value: function assert(value) {
      if (!(value instanceof ZodError)) {
        throw new Error("Not a ZodError: ".concat(value));
      }
    }
  }]);
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.ZodError = ZodError;

ZodError.create = function (issues) {
  var error = new ZodError(issues);
  return error;
};